// client-web-appsuite/src/constants/windows.js

let WINDOWS = {
    ABSTRACT: 'abstract',
    BASE: 'base'
}

WINDOWS = Object.freeze(WINDOWS)

export default WINDOWS